import * as angular from "angular";
import { DialogUtils } from "../../helper/dialog.helper";

let ViewSignatureDialogComponent = {
    selector: "vcViewSignatureDialog",
    templateUrl:
        "/angular/components/signature/view-signature-dialog.component.html",
    bindings: {
        signature: "=",
    },
    controller: class ViewSignatureDialogController {
        // * bindings for typescript compiler *
        public signature: any;
        // ************************************

        public dialog: DialogUtils;
        public $scope: any;
        public $sce: any;
        public showSignature;

        constructor(
            $scope: any,
            $sce: any,
            DialogUtils: DialogUtils,
            __app_type: string
        ) {
            this.dialog = DialogUtils;
            this.$scope = $scope;
            this.$sce = $sce;
            this.showSignature = false;
        }

        $onInit() {
            setTimeout(() => {
                this.showSignature = true;
            }, 500);
        }

        cancel(): void {
            this.dialog.cancel();
        }
    },
};

angular
    .module("signature")
    .component(
        ViewSignatureDialogComponent.selector,
        ViewSignatureDialogComponent
    );
